import { gql } from 'apollo-boost';

const jobBenefitsQuery = (locationSlug = '') => gql`
    query pageQuery {
        entry(slug: "${locationSlug}", type: Location) {
            ... on Location {
                jobBenefitsSelector {
                    ... on JobBenefitsModule {
                        jobBenefits {
                            ... on JobBenefitsJobBenefitsItem {
                                theBenefits {
                                    theBenefitsTitle
                                    theBenefitsDescription
                                }
                                thePerks {
                                    thePerksIcon {
                                        url
                                    }
                                    thePerksTitle
                                    thePerksDescription
                                }
                                jobBenefitsDescription
                            }
                        }
                    }
                }
            }
        }
    }
`;

export const jobLocationQuery = (locationSlug = '') => gql`
    query pageQuery {
        entry(slug: "${locationSlug}", type: Location) {
            ... on Location {
                slug
                locationHeader {
                    headerBackground {
                        url
                        title
                    }
                }
            }
        }
    }
`;

export default jobBenefitsQuery;
